import { isNil, toString } from 'lodash';
import { IS_REQUIRED_ERROR } from 'common/constants/messages/validations';
import { SHEET_ALIASES_CONSTANTS } from 'pages/ValuationsAllocation/common/constants/futureExit/';
import { CellValidationParams } from 'pages/ValuationsAllocation/types';
import { getObjectValue } from 'utilities';

const { FE_FUTURE_EQUITY_SPREADSHEET_EXIT_DATE } = SHEET_ALIASES_CONSTANTS;

const customValidations = (params: CellValidationParams) => {
  const { cell, addFeedbackFromCell, removeFeedbackFromCell } = params;
  const { alias, isRequired } = getObjectValue(cell);

  // A Future Exit cannot be discounted without an exit date, so block the save instead of
  // letting the backend treat it as zero years (or fail the reallocation).
  if (alias === FE_FUTURE_EQUITY_SPREADSHEET_EXIT_DATE && isRequired && cell) {
    if (isNil(cell.value) || toString(cell.value).trim() === '') {
      addFeedbackFromCell?.(cell, IS_REQUIRED_ERROR);
      return;
    }

    removeFeedbackFromCell?.(cell, IS_REQUIRED_ERROR);
  }
};

export default customValidations;
